// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1H0M3","bigColWidth":"Table_bigColWidth__2iEQ6","biggerColWidth":"Table_biggerColWidth__1aiPz","row":"Table_row__1Mnz-","col":"Table_col__PgId6"};